import React from 'react'
import { ChartContainer } from '../styles'
import { Line } from 'react-chartjs-2'

function RevenueChart({xData, revenue}) {

    const data = {
      labels: xData,
      datasets: [
        {
          label: 'Revenue',
          data: revenue,
          backgroundColor: [
            '#E8F3F5'
          ],
          borderColor: [
              '#45ACC2'
          ],
        }
      ],
    }
    
    const options = {
      maintainAspectRatio: false,
      scales: {
        xAxes: [ {
          scaleLabel: {
            display: true,
            labelString: 'Week'
          } 
        } ],
        yAxes: [{
          ticks: {
              beginAtZero: true
          }
        }]
      }
    }

    return(
          <ChartContainer className="chart-container">
              <Line data={data} options={options}/>
          </ChartContainer>
    )
}

export default RevenueChart